import { useSelector } from 'react-redux';

export const usePermissionCheck = (permissionCheck) => {
  const {
    info: { 
      display_name: teamName,
      platform_permissions_enabled
    },
    misc: {
      user_permissions: userPermissions
    }
  } = useSelector(({ team }) => team);
  
  // Check if user has the required permission
  const hasPermission = userPermissions?.[permissionCheck];
  let permissionDisabled = platform_permissions_enabled && !hasPermission;
  // permissionDisabled = false;
  return {
    permissionDisabled, 
  };
}; 